import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchAllIntermodalVehicleTypes } from "../../../common/api";
import { assertIsDefined } from "../../../common/asserts/assert";
import {
  getFirstValidIntermodalCustomer,
  getValidIntermodalCustomer,
} from "../../../common/utils/customerUtils";
import { formatServerDate } from "../../../common/utils/dates/dateUtils";
import type { StoreState } from "../../../store/storeState";
import { getAccount } from "../../settings/settingsReducer";
import {
  createEmptyCreateFormModel,
  initializeCreateIntermodalFormState,
} from "../createIntermodalReducer";
import { getVehicleDimensions } from "../utils";

export const initializeIntermodalCreateThunk = createAsyncThunk<
  void,
  { goodId: string },
  { state: StoreState }
>(
  "initializeIntermodalCreateForm",
  async ({ goodId }, { dispatch, getState }) => {
    const departureDate = formatServerDate(new Date());
    const departureTime = "00:00";
    const defaultVehicleTypeCode = "TR";

    const account = getAccount(getState());
    assertIsDefined(account, "Account is not initialized");

    const intermodalCustomer =
      getValidIntermodalCustomer(account.accountSettings.bookCustomer) ??
      getFirstValidIntermodalCustomer(account.customers);

    const vehicleTypes = await fetchAllIntermodalVehicleTypes();
    const defaultVehicleType = vehicleTypes.find(
      (vt) => vt.code === defaultVehicleTypeCode,
    );

    const fields = defaultVehicleType
      ? getVehicleDimensions(defaultVehicleType)
      : {};

    dispatch(
      initializeCreateIntermodalFormState(
        createEmptyCreateFormModel(goodId, {
          customer: intermodalCustomer,
          vehicleType: defaultVehicleType ?? null,
          ...fields,
          departureDate,
          departureTime,
        }),
      ),
    );
  },
);
